import { useState } from "react";

interface Props {
  message: string;
  children: any;
  position: string; //along with position we can add the classnames for the tooltip based on requirement
}

function Tooltip({ message, children, position }: Props) {
  const [isVisible, setisVisible] = useState(false);
  return (
    <>
      {message && message.length > 0 && (
        <div
          className="group relative flex "
          onMouseEnter={() => setisVisible(true)}
          onMouseLeave={() => setisVisible(false)}
        >
          {children}
          {isVisible && (
            <div
              className={` absolute  bg-secondary/70 text-white dark:text-black font-extralight  z-10 text-center scale-0 transition-all rounded py-1  text-xs group-hover:scale-100 border-0 ring-1 ring-border ${position}`}
            >
              {message}
            </div>
          )}
        </div>
      )}
      {!message && <>{children}</>}
    </>
  );
}

export default Tooltip;
